<template>
    <v-app-bar app  class="noprint" elevation="0" :class="drawerClass">
        <v-app-bar-title style="width: 320px;">
            <v-list-item  dense :to="{
                name: 'Dashboard'
            }">
                <v-list-item-avatar size="36px" class="ml-n1" tile>
                    <img :src="logo" />
                </v-list-item-avatar>
                <v-list-item-content >
                    <v-list-item-title>
                        <span class="hidden-sm-and-down title text--darken-2 grey--text">{{ $appName }}</span>
                        <strong class="deep-orange--text text--darken-1 subtitle-2" v-if="developmentMode">DEV</strong>
                    </v-list-item-title>
                    <v-list-item-subtitle class="mt-n2">
                        <strong class="primary--text text--darken-2">Siniestros Autos</strong>
                    </v-list-item-subtitle>
                </v-list-item-content>
            </v-list-item>
        </v-app-bar-title>
    </v-app-bar>
</template>

<script>

import logo from '@/assets/logo.png'

export default {
  name: 'TheLayoutToolbar',
  components: {

  },
  data() {
    const PRODUCTION = process.env.NODE_ENV === 'production'

    return {
      developmentMode: !PRODUCTION,
      drawerClass: PRODUCTION
        ? 'grey lighten-3 drawer-container elevation-2'
        : 'deep-orange lighten-2 dev-drawer-container elevation-2',
      logo

    }
  }
}
</script>

<style lang="scss" scoped>
@media print {
  .noprint {
    display: none;
  }
}
</style>
